import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { of, switchMap, catchError } from 'rxjs';

import { QuestionsService } from '@shared/services/questions.service';
import { AuthService } from '@shared/services/auth.service';
import type { PortfolioApi } from '@shared/interfaces/portfolio.interface';
import { isNullOrUndefined } from '@utils/predicates';
import { parseNumericValue } from '@utils/number-parser';

export const publicPortfolioResolver: ResolveFn<PortfolioApi | null> = (route) => {
  const questionsService = inject(QuestionsService);
  const authService = inject(AuthService);

  const portfolioId = route.queryParamMap.get('portfolioId');
  const amountParam = route.queryParamMap.get('amount');

  if (isNullOrUndefined(portfolioId) || isNullOrUndefined(amountParam)) {
    return of(null);
  }

  const amount = parseNumericValue(amountParam);
  if (isNaN(amount)) {
    return of(null);
  }

  return authService.ensureToken().pipe(
    switchMap(() => questionsService.getPublicPortfolio(portfolioId, amount)),
    catchError(() => of(null))
  );
};